var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container section has-text-centered"},[_c('h1',{staticClass:"title has-text-weight-light badabing-error-main"},[_vm._v("404: Page Not Found")]),_c('figure',{staticClass:"image"},[_c('img',{staticStyle:{"width":"200px","margin":"auto"},attrs:{"src":require("@/assets/404.jpeg")}})])])])
}]

export { render, staticRenderFns }